module.exports = __webpack_public_path__ + "static/media/pagamentoSucesso.553d7937.svg";